import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { apiUrl,brands } from "../../config/config";
import SEO from "../SEO";
import BlogPreviewSkeleton from "./BlogPreviewSkeleton";


const BlogPreview = () => {
  const { slug } = useParams();

  const [blog, setBlog] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  /* =========================
     FETCH SINGLE BLOG (SLUG)
  ========================== */
  useEffect(() => {
    setLoading(true);

    fetch(`${apiUrl}/api/blogs/${slug}`)
      .then(res => res.json())
      .then(data => {
        setBlog(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [slug]);

  /* =========================
     FETCH RELATED BLOGS (ID)
  ========================== */
  useEffect(() => {
    if (!blog?.id) return;

    fetch(`${apiUrl}/api/${brands}/blogs/${blog.id}/related`)
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          setRelatedBlogs(res.data);
        }
      })
      .catch(err => console.error(err));
  }, [blog]);

 if (loading) {
  return <BlogPreviewSkeleton />;
}

  if (!blog) {
    return <p className="text-center py-10 text-red-500">Blog not found.</p>;
  }

  return (
    <>
       <SEO
        title={blog.meta_title || blog.title}
        description={
          blog.meta_description ||
          blog.short_description ||
          "Read this blog on Inkox"
        }
        keywords={blog.meta_keywords || ""}
  
      /> 
    <div className="max-w-6xl mx-auto px-4 py-10">

      {/* BACK BUTTON */}
      <Link
        to="/blogs"
        className="inline-block mb-6 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
      >
        ← Back to Blogs
      </Link>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

        {/* ======================
            BLOG CONTENT
        ======================= */}
        <div className="md:col-span-2 bg-white rounded-lg shadow overflow-hidden">

          {blog.image && (
            <img
              src={`${apiUrl}/storage/${blog.image}`}
              alt={blog.title}
              className="w-full h-96 object-cover"
            />
          )}

          <div className="p-6">
            <h1 className="text-3xl font-bold mb-2">
              {blog.title}
            </h1>

            <p className="text-sm text-gray-500 mb-4">
              Category: {blog.category?.name || "N/A"}
            </p>

            <hr className="mb-6" />

            <div
              className="prose max-w-none"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />

            {/* TAGS */}
            {blog.tags && blog.tags.length > 0 && (
              <div className="mt-6">
                <h4 className="font-semibold mb-2">Tags:</h4>
                <div className="flex flex-wrap gap-2">
                  {blog.tags.map(tag => (
                    <span
                      key={tag.id}
                      className="text-xs bg-gray-200 px-2 py-1 rounded"
                    >
                      #{tag.name}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ======================
            RELATED BLOGS SIDEBAR
        ======================= */}
        <div className="md:col-span-1">

          <div className="bg-white rounded-lg shadow p-4 sticky top-24">

            <h3 className="text-lg font-bold mb-4">
              Related Blogs
            </h3>

            {relatedBlogs.length === 0 ? (
              <p className="text-sm text-gray-500">
                No related blogs found.
              </p>
            ) : (
              <div className="space-y-4">
                {relatedBlogs.map(rb => (
                  <Link
                    key={rb.id}
                    to={`/blogs/${rb.slug}`}
                    className="flex gap-3 hover:bg-gray-100 p-2 rounded transition"
                  >
                    {rb.image && (
                      <img
                        src={`${apiUrl}/storage/${rb.image}`}
                        alt={rb.title}
                        className="w-16 h-16 object-cover rounded"
                      />
                    )}

                    <div>
                      <p className="text-sm font-semibold leading-snug">
                        {rb.title}
                      </p>
                      <span className="text-xs text-gray-500">
                        {rb.category?.name}
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
    </>
  );
};

export default BlogPreview;
